import React from 'react'
import cartData from '../models/cart';
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'

export class CatalogCartComponent extends React.Component {
  constructor(props) {
    super(props)
    cartData.subject.subscribe(()=> {
      this.forceUpdate()
    })

    this.goToCart = this.goToCart.bind(this)
  }

  goToCart() {
    location.href = '/cart'
  }

  render() {
    const count = cartData.cartTotalItems()
    const sum = cartData.sum()
    if(cartData.orderMade) {
      return null
    }
    return (
      <div className="catalog-cart" onClick={this.goToCart}>
        <div className="catalog-cart__count">
          <span>В корзине</span>
          <strong>{count}</strong>
        </div>
        { count > 0 &&
          <div className="catalog-cart__total">
            <span>на сумму</span>
            <CurFormatComponent type="strong" price={sum}/>
          </div>
        }
        { count == 0 &&
            <div className="catalog-cart__total catalog-cart__total--empty">
              <span>Добавьте товары в корзину</span>
            </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/catalog_cart/catalog_cart.component.jsx